module.exports = __webpack_public_path__ + "img/pa.3eab15fa.svg";